module.exports = __webpack_public_path__ + "img/breathe_free_poster.420940f0.jpg";